$(function () {

    // person to emploee check hiring 
    $(document).on('change', '#calendar-absence_type', function (e) {
        var type = $(this).val();
        console.log(type);

        // Nemoc
        if (type == 7) {
            $('#section-sickness').removeClass("d-none");
        } else {
            $('#section-sickness').addClass("d-none");
        }

        // Dovolená
        if (type == 1) {
            $('#section-holiday').removeClass("d-none");
            $('#holiday_approved').prop('checked', false);
        } else {
            $('#section-holiday').addClass("d-none");
            $('#holiday_approved').prop('checked', true);
        }
        return true;
    });

});